import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequestWithParams,
  deleteRequest,
} from "../../services/API";
import { isEmpty } from "../../services/validation";

const FETCH_ACCESS_LOGS = "fetchAccessLogs";
const DELETE_ACCESS_LOG = "deleteAccessLog";
const EXPORT_ACCESS_LOGS = "exportAccessLogs";

export const fetchAccessLogsAction = createAsyncThunk(
  FETCH_ACCESS_LOGS,
  async (requestInfo, { rejectWithValue }) => {
    let requestUrl = "?page=" + requestInfo.page + "&limit=" + requestInfo.limit;

    try {
      if (!isEmpty(requestInfo.searchText)) {
        requestUrl = requestUrl + "&search=" + requestInfo.searchText;
      }

      if (!isEmpty(requestInfo.start_date)) {
        requestUrl = requestUrl + "&start_date=" + requestInfo.start_date;
      }

      if (!isEmpty(requestInfo.end_date)) {
        requestUrl = requestUrl + "&end_date=" + requestInfo.end_date;
      }

      if (!isEmpty(requestInfo.access_type)) {
        requestUrl = requestUrl + "&access_type=" + requestInfo.access_type;
      }

      if (!isEmpty(requestInfo.source)) {
        requestUrl = requestUrl + "&source=" + requestInfo.source;
      }

      if (!isEmpty(requestInfo.user_email)) {
        requestUrl = requestUrl + "&user_email=" + requestInfo.user_email;
      }

      if (!isEmpty(requestInfo.subscription_type)) {
        requestUrl = requestUrl + "&subscription_type=" + requestInfo.subscription_type;
      }

      if (!isEmpty(requestInfo.sortBy)) {
        requestUrl = requestUrl + "&sortBy=" + requestInfo.sortBy;
      }

      if (!isEmpty(requestInfo.order)) {
        requestUrl = requestUrl + "&order=" + requestInfo.order;
      }

      let fetchAccessLogsResult = await getRequestWithParams(
        requestInfo.language,
        "accessLogs",
        requestUrl,
        true
      );
      return fetchAccessLogsResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

export const deleteAccessLogAction = createAsyncThunk(
  DELETE_ACCESS_LOG,
  async ({ language, logId }, { rejectWithValue }) => {
    try {
      let deleteAccessLogResult = await deleteRequest(
        language,
        "accessLogs",
        logId,
        true
      );
      return deleteAccessLogResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

export const exportAccessLogsAction = createAsyncThunk(
  EXPORT_ACCESS_LOGS,
  async (requestInfo, { rejectWithValue }) => {
    let requestUrl = "?";

    try {
      if (!isEmpty(requestInfo.searchText)) {
        requestUrl = requestUrl + "&search=" + requestInfo.searchText;
      }

      if (!isEmpty(requestInfo.start_date)) {
        requestUrl = requestUrl + "&start_date=" + requestInfo.start_date;
      }

      if (!isEmpty(requestInfo.end_date)) {
        requestUrl = requestUrl + "&end_date=" + requestInfo.end_date;
      }

      if (!isEmpty(requestInfo.access_type)) {
        requestUrl = requestUrl + "&access_type=" + requestInfo.access_type;
      }

      if (!isEmpty(requestInfo.subscription_type)) {
        requestUrl = requestUrl + "&subscription_type=" + requestInfo.subscription_type;
      }

      if (!isEmpty(requestInfo.sortBy)) {
        requestUrl = requestUrl + "&sortBy=" + requestInfo.sortBy;
      }

      if (!isEmpty(requestInfo.order)) {
        requestUrl = requestUrl + "&order=" + requestInfo.order;
      }

      let exportAccessLogsResult = await getRequestWithParams(
        requestInfo.language,
        "accessLogsExport",
        requestUrl,
        true
      );
      return exportAccessLogsResult;
    } catch (error) {
      try {
        return rejectWithValue(JSON.parse(error.message));
      } catch (parseError) {
        return rejectWithValue({ message: error.message || "Export failed" });
      }
    }
  }
);